import React, { Component } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Card, Tag, Button, message } from 'antd'
import { API_FORCE_LOGOUT, API_RANDOM_PASSWORD, API_USER_BLOCK } from '../../../api'

import './profile-detail.css'

class ProfileDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      btnForceLogut: false,
      btnRandomPass: false,
      btnBlock: false,
    }
  }

  handleForceLogout = (e) => {
    e.preventDefault()
    this.setState({ btnForceLogut: true })
    API_FORCE_LOGOUT(this.props.userId)
      .then(() => {
        this.setState({ btnForceLogut: false })
        message.success('Force Logout Success ')
      })
      .catch(() => {
        this.setState({ btnForceLogut: false })
        message.error('Force Logout Error')
      })
  }

  handleRandomPassword = (e) => {
    e.preventDefault()
    this.setState({ btnRandomPass: true })
    API_RANDOM_PASSWORD(this.props.userId)
      .then(() => {
        this.setState({ btnRandomPass: false })
        message.success('Random Password Success ')
      })
      .catch(() => {
        this.setState({ btnRandomPass: false })
        message.error('Random Password Error')
      })
  }

  handleUserBlock = (e, status = true) => {
    e.preventDefault()
    this.setState({ btnBlock: true })
    API_USER_BLOCK(this.props.userId, status)
      .then(() => {
        this.setState({ btnBlock: false })
        message.success('User Block Success ')
      })
      .catch(() => {
        this.setState({ btnBlock: false })
        message.error('User Block Error')
      })
  }

  render() {
    const { userId, dataUser } = this.props

    return (
      <div>
        <Card>
          <div>
            <br />
            <div className="data-profile"><div>User ID</div>         <div>: {userId}</div></div>
            <div className="data-profile"><div>Full name</div>       <div>: {dataUser.fullName}</div></div>
            <div className="data-profile"><div>Email</div>           <div>: {dataUser.email}</div></div>
            <div className="data-profile"><div>Phone</div>           <div>: {dataUser.phone}</div></div>

            <br />
            <div className="data-profile"><strong>Membership</strong></div>
            <div className="data-profile"><div>Member since</div>    <div>: {moment(dataUser.createdAt).format('DD MMM YYYY, HH:mm')}</div></div>
            <div className="data-profile"><div>Status</div>
              <div> : &nbsp;
                { dataUser.createdAt !== 1 ? <Tag color="#87d068">Active</Tag> : <Tag color="#f50">Unactive</Tag> }
                { dataUser.blocked !== 1 ? <Tag color="#87d068">Not Blocked</Tag> : <Tag color="#f50">Blocked</Tag> }
              </div>
            </div>
            <br /><br />
            <div>
              <Button className="data-profile-btn-orange" size="large" loading={this.state.btnForceLogut} onClick={this.handleForceLogout}>FORCE LOGOUT</Button>
              <Button className="data-profile-btn-orange" size="large" loading={this.state.btnRandomPass} onClick={this.handleRandomPassword}>SET RANDOM PASSWORD</Button>
              {
                dataUser.blocked !== 1
                ? <Button className="data-profile-btn-red" loading={this.state.btnBlock} size="large" onClick={this.handleUserBlock}>BLOCK</Button>
                : <Button className="data-profile-btn-orange" loading={this.state.btnBlock} size="large" onClick={e => this.handleUserBlock(e, 'false')}>UNBLOCK</Button>
              }
            </div>
          </div>
        </Card>
      </div>
    )
  }
}

ProfileDetail.defaultProps = {
  userId: '',
  dataUser: {},
}

ProfileDetail.propTypes = {
  userId: PropTypes.string,
  dataUser: PropTypes.object,
}

export default ProfileDetail



// WEBPACK FOOTER //
// src/pages/user/profile-detail/index.js